import { Alert, FormInstance } from "antd";
import { Form, Input } from "antd";
import MobileBottomSpacer from "../../Components/MobileBottomSpacer";
import { Id, WishlistItem } from "../../../data/types";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { useEffect, useState } from "react";
import WishImage from "./WishImage";
import UploadBox from "./UploadBox";
import { WishModifier } from "../../../data/hooks";

interface EditFormProps {
  wishlistId: Id;
  wish: WishlistItem;
  isLoading: boolean;
  form: FormInstance;
  onSubmit: WishModifier;
  showDataInfo?: boolean;
}

export default function EditForm({
  wish,
  isLoading,
  form,
  onSubmit,
  showDataInfo,
}: EditFormProps) {
  const [imageUrl, setImageUrl] = useState<string | null>(wish.imageLink);
  useEffect(() => {
    setImageUrl(wish.imageLink);
    form.resetFields();
  }, [wish]);

  const onSubmitCallback = async (values: WishlistItem) => {
    setImageUrl(null);
    onSubmit({ ...wish, ...values });
    form.resetFields();
  };

  const setUrl = (url: string | undefined) => {
    form.setFieldValue("imageLink", url);
    setImageUrl(url || null);
  };

  return (
    <>
      {showDataInfo &&
        wish.link &&
        (wish.name || wish.description ? (
          <Alert
            message="We extracted some product info, but you can update it to your liking!"
            type="success"
            showIcon
            icon={"✨"}
          />
        ) : (
          <Alert
            message="We were not able to extract product info, please provide it manually"
            type="error"
            showIcon
            icon={"😔"}
          />
        ))}
      <Form
        form={form}
        name="item-edit"
        initialValues={wish}
        onFinish={onSubmitCallback}
        disabled={isLoading}
        preserve={false}
        clearOnDestroy={true}
      >
        <div className="flex flex-col items-center gap-6 p-6 md:flex-row">
          <div className="flex flex-col items-center gap-4 md:w-1/2">
            {(form.getFieldValue("imageLink") || imageUrl) && (
              <WishImage
                imageLink={form.getFieldValue("imageLink") || imageUrl}
              />
            )}
            <UploadBox imageId={wish.id} setUrl={setUrl} />
          </div>

          <div className="md:w-1/2">
            <Form.Item name="name" rules={[{ required: true }]}>
              <TextField label="Wish name" variant="outlined" fullWidth />
            </Form.Item>
            <Form.Item name="link">
              <TextField label="URL" variant="outlined" fullWidth />
            </Form.Item>
            <Form.Item style={{ marginBottom: 0 }}>
              <Form.Item
                name="price"
                style={{ display: "inline-block", width: "calc(50% - 4px)" }}
              >
                <TextField label="Price" variant="outlined" />
              </Form.Item>
              <Form.Item
                name="currency"
                style={{
                  display: "inline-block",
                  width: "calc(50% - 4px)",
                  marginLeft: 8,
                }}
              >
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    Currency
                  </InputLabel>
                  <Select
                    label="Currency"
                    labelId="demo-simple-select-label"
                    onChange={(ev) =>
                      form.setFieldValue("currency", ev.target.value)
                    }
                    defaultValue={wish?.currency}
                  >
                    <MenuItem value="EUR">EUR</MenuItem>
                    <MenuItem value="GBP">GBP</MenuItem>
                    <MenuItem value="PLN">PLN</MenuItem>
                    <MenuItem value="RUB">RUB</MenuItem>
                    <MenuItem value="UAH">UAH</MenuItem>
                    <MenuItem value="USD">USD</MenuItem>
                  </Select>
                </FormControl>
              </Form.Item>
            </Form.Item>
            <Form.Item name="imageLink" className="hidden">
              <Input hidden />
            </Form.Item>
            <Form.Item name="description">
              <TextField
                label="Description"
                variant="outlined"
                multiline
                rows={5}
                fullWidth
                helperText="Write what this gift means to you. Your friends will see this text."
              />
            </Form.Item>
          </div>
        </div>
      </Form>
      <MobileBottomSpacer />
    </>
  );
}
